import { groupByMapLabel } from '@jumbo/utils/mapHelpers';
import { useState, useEffect } from 'react';
import customAxios from '../util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { useToast } from 'context/tostifyContext';

const useWeighbridgeData = () => {
  const [weighbridgeDetails, setWeighbridgeDetails] = useState([]);
  const [destinationList, setDestinationList] = useState([]);
  const [mapData, setMapData] = useState(null);
  const [showMap, setShowMap] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(false);

  const { showToast } = useToast();

  const fetchCustomerLocations = async () => {
    try {
      const res = await customAxios.get('/CRM/GetAllCustomerLocations', {
        headers: authHeader(),
      });
      if (res.status === 200) {
        setDestinationList(res.data);
      }
    } catch (error) {
      console.error('Error fetching destinations:', error);
    }
  };
  // Fetch weighbridge details
  const fetchWeighbridgeDetails = async () => {
    try {
      const res = await customAxios.post(
        '/Ops/GetCustomerWeighbridgeDetails',
        {},
        {
          headers: authHeader(),
        },
      );
      if (res.status === 200) {
        setWeighbridgeDetails(res.data);
      }
    } catch (error) {
      console.error('Error fetching weighbridge details:', error);
    }
  };

  useEffect(() => {
    fetchCustomerLocations();
    fetchWeighbridgeDetails();
  }, []);

  // Fetch map data
  const fetchMapData = async rowData => {
    console.log('row', rowData);
    if (!rowData?.destinationSiteAssessmentID) return;

    try {
      const [pins, polygons, lines] = await Promise.all([
        customAxios.get(`/SiteDetails/GetSiteDetailsMapCoordinates/${rowData.destinationSiteAssessmentID}?mapType=pins`, {
          headers: authHeader(),
        }),
        customAxios.get(`/SiteDetails/GetSiteDetailsMapCoordinates/${rowData.destinationSiteAssessmentID}?mapType=polygon`, {
          headers: authHeader(),
        }),
        customAxios.get(`/SiteDetails/GetSiteDetailsMapCoordinates/${rowData.destinationSiteAssessmentID}?mapType=line`, {
          headers: authHeader(),
        }),
      ]);

      console.log(pins.data, polygons.data, lines.data);

      const lineData = groupByMapLabel(lines.data, 'line');
      const polygonData = groupByMapLabel(polygons.data, 'polygon');

      setMapData({ pins: pins.data, polygons: polygonData, lines: lineData });
    } catch (err) {
      console.error('Error fetching map data:', err);
    }
  };

  // Map modal handlers
  const openMapModal = rowData => {
    setShowMap(true);
    fetchMapData(rowData);
  };

  const closeMapModal = () => {
    setShowMap(false);
    setMapData(null);
  };

  // Add/Edit modal handlers
  const openAddModal = () => {
    setEditData(null);
    setShowModal(true);
  };

  const openEditModal = rowData => {
    console.log('row ===', rowData);
    setEditData(rowData);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditData(null);
  };

  // Save weighbridge (Add or Edit)
  const saveWeighbridge = async formData => {
    setLoading(true);
    try {
      const endpoint = editData ? '/Ops/EditCustomerWeighbridgeDetails' : '/Ops/AddCustomerWeighbridgeDetails';

      const payload = {
        customerName: formData.customerName,
        destinationName: formData.destinationName,
        custCode: formData.custCode,
        weighbridgeName: formData.weighbridgeName,
        destinationSiteAssessmentID: formData.destinationSiteAssessmentID,
        weighbridgeSiteAssessmentID: formData.weighbridgeSiteAssessmentID || 0,
        adminEmailAddress: formData.adminEmailAddress,
        accountsEmailAddress: formData.accountsEmailAddress,
        ...(editData && {
          id: formData.id,
        }),
      };

      console.log('payload ===', payload, formData);

      const res = await customAxios.post(endpoint, payload, {
        headers: authHeader(),
      });

      if (res.status === 200) {
        // Refresh the list
        await fetchWeighbridgeDetails();
        closeModal();
        showToast(editData ? 'Updated successfully' : 'Added successfully', 'success');
      }
    } catch (error) {
      console.error('Error saving weighbridge:', error);
      showToast(error.response?.data?.message || 'An error occurred while saving', 'error');
    } finally {
      setLoading(false);
    }
  };

  return {
    weighbridgeDetails,
    destinationList,
    openMapModal,
    closeMapModal,
    showMap,
    mapData,
    showModal,
    editData,
    openAddModal,
    openEditModal,
    closeModal,
    saveWeighbridge,
    loading,
  };
};

export default useWeighbridgeData;
